/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from "axios";
import { Configuration } from "../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "../base";
// @ts-ignore
import { MergeUndoIds } from "../models";
// @ts-ignore
import { MergeWords } from "../models";
// @ts-ignore
import { Word } from "../models";
/**
 * MergeApi - axios parameter creator
 * @export
 */
export const MergeApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blacklistAdd: async (
      projectId: string,
      requestBody: Array<string>,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("blacklistAdd", "projectId", projectId);
      // verify required parameter 'requestBody' is not null or undefined
      assertParamExists("blacklistAdd", "requestBody", requestBody);
      const localVarPath =
        `/v1/projects/{projectId}/merge/blacklist/add`.replace(
          `{${"projectId"}}`,
          encodeURIComponent(String(projectId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findIdenticalPotentialDuplicates: async (
      projectId: string,
      maxInList: number,
      maxLists: number,
      ignoreProtected: boolean,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists(
        "findIdenticalPotentialDuplicates",
        "projectId",
        projectId
      );
      // verify required parameter 'maxInList' is not null or undefined
      assertParamExists(
        "findIdenticalPotentialDuplicates",
        "maxInList",
        maxInList
      );
      // verify required parameter 'maxLists' is not null or undefined
      assertParamExists(
        "findIdenticalPotentialDuplicates",
        "maxLists",
        maxLists
      );
      // verify required parameter 'ignoreProtected' is not null or undefined
      assertParamExists(
        "findIdenticalPotentialDuplicates",
        "ignoreProtected",
        ignoreProtected
      );
      const localVarPath =
        `/v1/projects/{projectId}/merge/findidenticaldups/{maxInList}/{maxLists}/{ignoreProtected}`
          .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
          .replace(`{${"maxInList"}}`, encodeURIComponent(String(maxInList)))
          .replace(`{${"maxLists"}}`, encodeURIComponent(String(maxLists)))
          .replace(
            `{${"ignoreProtected"}}`,
            encodeURIComponent(String(ignoreProtected))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findPotentialDuplicates: async (
      projectId: string,
      maxInList: number,
      maxLists: number,
      ignoreProtected: boolean,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("findPotentialDuplicates", "projectId", projectId);
      // verify required parameter 'maxInList' is not null or undefined
      assertParamExists("findPotentialDuplicates", "maxInList", maxInList);
      // verify required parameter 'maxLists' is not null or undefined
      assertParamExists("findPotentialDuplicates", "maxLists", maxLists);
      // verify required parameter 'ignoreProtected' is not null or undefined
      assertParamExists(
        "findPotentialDuplicates",
        "ignoreProtected",
        ignoreProtected
      );
      const localVarPath =
        `/v1/projects/{projectId}/merge/finddups/{maxInList}/{maxLists}/{ignoreProtected}`
          .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
          .replace(`{${"maxInList"}}`, encodeURIComponent(String(maxInList)))
          .replace(`{${"maxLists"}}`, encodeURIComponent(String(maxLists)))
          .replace(
            `{${"ignoreProtected"}}`,
            encodeURIComponent(String(ignoreProtected))
          );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {number} maxLists
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGraylistEntries: async (
      projectId: string,
      maxLists: number,
      userId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getGraylistEntries", "projectId", projectId);
      // verify required parameter 'maxLists' is not null or undefined
      assertParamExists("getGraylistEntries", "maxLists", maxLists);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("getGraylistEntries", "userId", userId);
      const localVarPath =
        `/v1/projects/{projectId}/merge/getgraylist/{maxLists}/{userId}`
          .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
          .replace(`{${"maxLists"}}`, encodeURIComponent(String(maxLists)))
          .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    graylistAdd: async (
      projectId: string,
      requestBody: Array<string>,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("graylistAdd", "projectId", projectId);
      // verify required parameter 'requestBody' is not null or undefined
      assertParamExists("graylistAdd", "requestBody", requestBody);
      const localVarPath =
        `/v1/projects/{projectId}/merge/graylist/add`.replace(
          `{${"projectId"}}`,
          encodeURIComponent(String(projectId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        requestBody,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hasGraylistEntries: async (
      projectId: string,
      userId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("hasGraylistEntries", "projectId", projectId);
      // verify required parameter 'userId' is not null or undefined
      assertParamExists("hasGraylistEntries", "userId", userId);
      const localVarPath = `/v1/projects/{projectId}/merge/hasgraylist/{userId}`
        .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
        .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {Array<MergeWords>} mergeWords
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mergeWords: async (
      projectId: string,
      mergeWords: Array<MergeWords>,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("mergeWords", "projectId", projectId);
      // verify required parameter 'mergeWords' is not null or undefined
      assertParamExists("mergeWords", "mergeWords", mergeWords);
      const localVarPath = `/v1/projects/{projectId}/merge`.replace(
        `{${"projectId"}}`,
        encodeURIComponent(String(projectId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        mergeWords,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrievePotentialDuplicates: async (
      projectId: string,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("retrievePotentialDuplicates", "projectId", projectId);
      const localVarPath =
        `/v1/projects/{projectId}/merge/retrievedups`.replace(
          `{${"projectId"}}`,
          encodeURIComponent(String(projectId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} projectId
     * @param {MergeUndoIds} mergeUndoIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undoMerge: async (
      projectId: string,
      mergeUndoIds: MergeUndoIds,
      options: any = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("undoMerge", "projectId", projectId);
      // verify required parameter 'mergeUndoIds' is not null or undefined
      assertParamExists("undoMerge", "mergeUndoIds", mergeUndoIds);
      const localVarPath = `/v1/projects/{projectId}/merge/undo`.replace(
        `{${"projectId"}}`,
        encodeURIComponent(String(projectId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        mergeUndoIds,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * MergeApi - functional programming interface
 * @export
 */
export const MergeApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MergeApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async blacklistAdd(
      projectId: string,
      requestBody: Array<string>,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.blacklistAdd(
        projectId,
        requestBody,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findIdenticalPotentialDuplicates(
      projectId: string,
      maxInList: number,
      maxLists: number,
      ignoreProtected: boolean,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Array<Word>>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.findIdenticalPotentialDuplicates(
          projectId,
          maxInList,
          maxLists,
          ignoreProtected,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findPotentialDuplicates(
      projectId: string,
      maxInList: number,
      maxLists: number,
      ignoreProtected: boolean,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.findPotentialDuplicates(
          projectId,
          maxInList,
          maxLists,
          ignoreProtected,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {number} maxLists
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getGraylistEntries(
      projectId: string,
      maxLists: number,
      userId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Array<Word>>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getGraylistEntries(
          projectId,
          maxLists,
          userId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async graylistAdd(
      projectId: string,
      requestBody: Array<string>,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.graylistAdd(
        projectId,
        requestBody,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async hasGraylistEntries(
      projectId: string,
      userId: string,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.hasGraylistEntries(
          projectId,
          userId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {Array<MergeWords>} mergeWords
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async mergeWords(
      projectId: string,
      mergeWords: Array<MergeWords>,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.mergeWords(
        projectId,
        mergeWords,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async retrievePotentialDuplicates(
      projectId: string,
      options?: any
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Array<Array<Word>>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.retrievePotentialDuplicates(
          projectId,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} projectId
     * @param {MergeUndoIds} mergeUndoIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async undoMerge(
      projectId: string,
      mergeUndoIds: MergeUndoIds,
      options?: any
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.undoMerge(
        projectId,
        mergeUndoIds,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * MergeApi - factory interface
 * @export
 */
export const MergeApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = MergeApiFp(configuration);
  return {
    /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    blacklistAdd(
      projectId: string,
      requestBody: Array<string>,
      options?: any
    ): AxiosPromise<Array<string>> {
      return localVarFp
        .blacklistAdd(projectId, requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findIdenticalPotentialDuplicates(
      projectId: string,
      maxInList: number,
      maxLists: number,
      ignoreProtected: boolean,
      options?: any
    ): AxiosPromise<Array<Array<Word>>> {
      return localVarFp
        .findIdenticalPotentialDuplicates(
          projectId,
          maxInList,
          maxLists,
          ignoreProtected,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {number} maxInList
     * @param {number} maxLists
     * @param {boolean} ignoreProtected
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findPotentialDuplicates(
      projectId: string,
      maxInList: number,
      maxLists: number,
      ignoreProtected: boolean,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .findPotentialDuplicates(
          projectId,
          maxInList,
          maxLists,
          ignoreProtected,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {number} maxLists
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getGraylistEntries(
      projectId: string,
      maxLists: number,
      userId: string,
      options?: any
    ): AxiosPromise<Array<Array<Word>>> {
      return localVarFp
        .getGraylistEntries(projectId, maxLists, userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {Array<string>} requestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    graylistAdd(
      projectId: string,
      requestBody: Array<string>,
      options?: any
    ): AxiosPromise<Array<string>> {
      return localVarFp
        .graylistAdd(projectId, requestBody, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    hasGraylistEntries(
      projectId: string,
      userId: string,
      options?: any
    ): AxiosPromise<boolean> {
      return localVarFp
        .hasGraylistEntries(projectId, userId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {Array<MergeWords>} mergeWords
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    mergeWords(
      projectId: string,
      mergeWords: Array<MergeWords>,
      options?: any
    ): AxiosPromise<Array<string>> {
      return localVarFp
        .mergeWords(projectId, mergeWords, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    retrievePotentialDuplicates(
      projectId: string,
      options?: any
    ): AxiosPromise<Array<Array<Word>>> {
      return localVarFp
        .retrievePotentialDuplicates(projectId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} projectId
     * @param {MergeUndoIds} mergeUndoIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    undoMerge(
      projectId: string,
      mergeUndoIds: MergeUndoIds,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .undoMerge(projectId, mergeUndoIds, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for blacklistAdd operation in MergeApi.
 * @export
 * @interface MergeApiBlacklistAddRequest
 */
export interface MergeApiBlacklistAddRequest {
  /**
   *
   * @type {string}
   * @memberof MergeApiBlacklistAdd
   */
  readonly projectId: string;

  /**
   *
   * @type {Array<string>}
   * @memberof MergeApiBlacklistAdd
   */
  readonly requestBody: Array<string>;
}

/**
 * Request parameters for findIdenticalPotentialDuplicates operation in MergeApi.
 * @export
 * @interface MergeApiFindIdenticalPotentialDuplicatesRequest
 */
export interface MergeApiFindIdenticalPotentialDuplicatesRequest {
  /**
   *
   * @type {string}
   * @memberof MergeApiFindIdenticalPotentialDuplicates
   */
  readonly projectId: string;

  /**
   *
   * @type {number}
   * @memberof MergeApiFindIdenticalPotentialDuplicates
   */
  readonly maxInList: number;

  /**
   *
   * @type {number}
   * @memberof MergeApiFindIdenticalPotentialDuplicates
   */
  readonly maxLists: number;

  /**
   *
   * @type {boolean}
   * @memberof MergeApiFindIdenticalPotentialDuplicates
   */
  readonly ignoreProtected: boolean;
}

/**
 * Request parameters for findPotentialDuplicates operation in MergeApi.
 * @export
 * @interface MergeApiFindPotentialDuplicatesRequest
 */
export interface MergeApiFindPotentialDuplicatesRequest {
  /**
   *
   * @type {string}
   * @memberof MergeApiFindPotentialDuplicates
   */
  readonly projectId: string;

  /**
   *
   * @type {number}
   * @memberof MergeApiFindPotentialDuplicates
   */
  readonly maxInList: number;

  /**
   *
   * @type {number}
   * @memberof MergeApiFindPotentialDuplicates
   */
  readonly maxLists: number;

  /**
   *
   * @type {boolean}
   * @memberof MergeApiFindPotentialDuplicates
   */
  readonly ignoreProtected: boolean;
}

/**
 * Request parameters for getGraylistEntries operation in MergeApi.
 * @export
 * @interface MergeApiGetGraylistEntriesRequest
 */
export interface MergeApiGetGraylistEntriesRequest {
  /**
   *
   * @type {string}
   * @memberof MergeApiGetGraylistEntries
   */
  readonly projectId: string;

  /**
   *
   * @type {number}
   * @memberof MergeApiGetGraylistEntries
   */
  readonly maxLists: number;

  /**
   *
   * @type {string}
   * @memberof MergeApiGetGraylistEntries
   */
  readonly userId: string;
}

/**
 * Request parameters for graylistAdd operation in MergeApi.
 * @export
 * @interface MergeApiGraylistAddRequest
 */
export interface MergeApiGraylistAddRequest {
  /**
   *
   * @type {string}
   * @memberof MergeApiGraylistAdd
   */
  readonly projectId: string;

  /**
   *
   * @type {Array<string>}
   * @memberof MergeApiGraylistAdd
   */
  readonly requestBody: Array<string>;
}

/**
 * Request parameters for hasGraylistEntries operation in MergeApi.
 * @export
 * @interface MergeApiHasGraylistEntriesRequest
 */
export interface MergeApiHasGraylistEntriesRequest {
  /**
   *
   * @type {string}
   * @memberof MergeApiHasGraylistEntries
   */
  readonly projectId: string;

  /**
   *
   * @type {string}
   * @memberof MergeApiHasGraylistEntries
   */
  readonly userId: string;
}

/**
 * Request parameters for mergeWords operation in MergeApi.
 * @export
 * @interface MergeApiMergeWordsRequest
 */
export interface MergeApiMergeWordsRequest {
  /**
   *
   * @type {string}
   * @memberof MergeApiMergeWords
   */
  readonly projectId: string;

  /**
   *
   * @type {Array<MergeWords>}
   * @memberof MergeApiMergeWords
   */
  readonly mergeWords: Array<MergeWords>;
}

/**
 * Request parameters for retrievePotentialDuplicates operation in MergeApi.
 * @export
 * @interface MergeApiRetrievePotentialDuplicatesRequest
 */
export interface MergeApiRetrievePotentialDuplicatesRequest {
  /**
   *
   * @type {string}
   * @memberof MergeApiRetrievePotentialDuplicates
   */
  readonly projectId: string;
}

/**
 * Request parameters for undoMerge operation in MergeApi.
 * @export
 * @interface MergeApiUndoMergeRequest
 */
export interface MergeApiUndoMergeRequest {
  /**
   *
   * @type {string}
   * @memberof MergeApiUndoMerge
   */
  readonly projectId: string;

  /**
   *
   * @type {MergeUndoIds}
   * @memberof MergeApiUndoMerge
   */
  readonly mergeUndoIds: MergeUndoIds;
}

/**
 * MergeApi - object-oriented interface
 * @export
 * @class MergeApi
 * @extends {BaseAPI}
 */
export class MergeApi extends BaseAPI {
  /**
   *
   * @param {MergeApiBlacklistAddRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */
  public blacklistAdd(
    requestParameters: MergeApiBlacklistAddRequest,
    options?: any
  ) {
    return MergeApiFp(this.configuration)
      .blacklistAdd(
        requestParameters.projectId,
        requestParameters.requestBody,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MergeApiFindIdenticalPotentialDuplicatesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */
  public findIdenticalPotentialDuplicates(
    requestParameters: MergeApiFindIdenticalPotentialDuplicatesRequest,
    options?: any
  ) {
    return MergeApiFp(this.configuration)
      .findIdenticalPotentialDuplicates(
        requestParameters.projectId,
        requestParameters.maxInList,
        requestParameters.maxLists,
        requestParameters.ignoreProtected,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MergeApiFindPotentialDuplicatesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */
  public findPotentialDuplicates(
    requestParameters: MergeApiFindPotentialDuplicatesRequest,
    options?: any
  ) {
    return MergeApiFp(this.configuration)
      .findPotentialDuplicates(
        requestParameters.projectId,
        requestParameters.maxInList,
        requestParameters.maxLists,
        requestParameters.ignoreProtected,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MergeApiGetGraylistEntriesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */
  public getGraylistEntries(
    requestParameters: MergeApiGetGraylistEntriesRequest,
    options?: any
  ) {
    return MergeApiFp(this.configuration)
      .getGraylistEntries(
        requestParameters.projectId,
        requestParameters.maxLists,
        requestParameters.userId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MergeApiGraylistAddRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */
  public graylistAdd(
    requestParameters: MergeApiGraylistAddRequest,
    options?: any
  ) {
    return MergeApiFp(this.configuration)
      .graylistAdd(
        requestParameters.projectId,
        requestParameters.requestBody,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MergeApiHasGraylistEntriesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */
  public hasGraylistEntries(
    requestParameters: MergeApiHasGraylistEntriesRequest,
    options?: any
  ) {
    return MergeApiFp(this.configuration)
      .hasGraylistEntries(
        requestParameters.projectId,
        requestParameters.userId,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MergeApiMergeWordsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */
  public mergeWords(
    requestParameters: MergeApiMergeWordsRequest,
    options?: any
  ) {
    return MergeApiFp(this.configuration)
      .mergeWords(
        requestParameters.projectId,
        requestParameters.mergeWords,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MergeApiRetrievePotentialDuplicatesRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */
  public retrievePotentialDuplicates(
    requestParameters: MergeApiRetrievePotentialDuplicatesRequest,
    options?: any
  ) {
    return MergeApiFp(this.configuration)
      .retrievePotentialDuplicates(requestParameters.projectId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {MergeApiUndoMergeRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MergeApi
   */
  public undoMerge(requestParameters: MergeApiUndoMergeRequest, options?: any) {
    return MergeApiFp(this.configuration)
      .undoMerge(
        requestParameters.projectId,
        requestParameters.mergeUndoIds,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
